// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"77":"1d7bc678","231":"f4f216ff","257":"235feeac","341":"928b046c","938":"eca013d5"}[chunkId] + ".chunk.js";
};